<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <h2 class="col-12 text-uppercase">
            {{$t('recharges.management')}}
            <hr>
        </h2>
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>

                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="recharges" :search="search" sort-by="name" class="elevation-1" :loading="reversements==undefined" loading-text="Chargement en cours...">
                    <template v-slot:item._type_transfert="{ item }">
                        <v-chip :color="getColor(item._type_transfert)" dark>
                            <span v-if="item._type_transfert=='bystep'">Manuel</span>
                            <span v-else>Automatique</span>
                        </v-chip>
                    </template>
                    <template v-slot:item.mean="{ item }">
                      <span> {{item.mean._means_paiement._name}} ({{item.mean._means_paiement._country._name}}) </span>
                    </template>



                    <template v-slot:item._amount="{ item }">
                      <span> {{item._amount}} XOF </span>
                    </template>
                    <template v-slot:item._fees="{ item }">
                      <span> {{item._fees}} XOF </span>
                    </template>
                    <template v-slot:item._net_amount="{ item }">
                      <span> {{item._net_amount}} XOF </span>
                    </template>

                    <template v-slot:item._status="{ item }">
                        <v-chip :color="getColor3(item._status)" dark>
                          {{item._status}}
                        </v-chip>
                    </template>

                    <template v-slot:item._created_at="{item}">
                        {{getDate(item._created_at)}}
                    </template>





                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>

                            <v-dialog v-model="dialogNote" max-width="500px">
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline">{{$t('comment')}}</span>
                                            </v-card-title>

                                            <v-card-text>

                                                {{note}}

                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click.prevent="closeNote()">{{$t('close')}}</v-btn>

                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                            <v-dialog v-model="dialog" max-width="800px">

                                <template v-slot:activator="{ on }" >
                                    <v-btn style="background: #29b3a6;color: #fff" @click="setdefault" class="mb-2" v-on="on">
                                          {{$t('recharges.new')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                  <v-card-title >
                                      <v-col md="11" lg="11" sm="11">
                                        <span class="headline">  {{ formTitle }} </span>
                                      </v-col>
                                      <v-col md="1" lg="1" sm="1">
                                        <v-icon style="cursor: pointer" @click="setdefaultClose" > mdi-close  </v-icon>
                                      </v-col>
                                  </v-card-title>

                                    <v-card-text>


                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">

                                            <v-stepper v-model="e1">
                                                <v-stepper-header>
                                                    <v-stepper-step :complete="e1 > 1" step="1">{{$t('recharges.etape1')}}
                                                    </v-stepper-step>

                                                    <v-divider></v-divider>

                                                    <v-stepper-step :complete="e1 > 2" step="2">{{$t('recharges.etape2')}}
                                                    </v-stepper-step>
                                                </v-stepper-header>

                                                <v-stepper-items>
                                                    <v-stepper-content step="1">


                                                        <div class="row">
                                                            <div class="col-12 col-md-6 col-lg-6"
                                                                 style="text-align: center">
                                                                <v-card
                                                                        @click="chooseItem('Mobile')"
                                                                        id="Mobile"
                                                                        class="ma-3 pa-6 chooseAll"
                                                                        outlined
                                                                        tile
                                                                        style="text-align: center"
                                                                >
                                                                <img src="images/phonemode.svg"
                                                                     width="120" alt=""
                                                                     style="padding: 2.5%">
                                                                    <h3 style="margin-top: 5%; font-weight: bold;"
                                                                        class="text-uppercase">
                                                                        {{$t('means_paiement.moyenmobile')}}</h3>

                                                                </v-card>
                                                            </div>
                                                            <div class="col-12 col-md-6 col-lg-6"
                                                                 style="text-align: center">
                                                                <v-card
                                                                        @click="chooseItem('Banque')"
                                                                        id="Banque"
                                                                        class="ma-3 pa-6 chooseAll"
                                                                        outlined
                                                                        tile
                                                                        style="text-align: center"
                                                                >
                                                                    <img src="images/bankmode2.png"
                                                                         width="120" alt="">
                                                                    <h3 style="margin-top: 5%; font-weight: bold"
                                                                        class="text-uppercase">
                                                                        {{$t('means_paiement.moyenbancaire')}}</h3>

                                                                </v-card>
                                                            </div>
                                                        </div>


                                                        <div class="text-right container">
                                                            <v-btn
                                                                    color="primary"
                                                                    @click="e1 = 2"
                                                                    :disabled="!step1"
                                                            >
                                                                {{$t('continuer')}}
                                                            </v-btn>
                                                        </div>


                                                    </v-stepper-content>



                                                    <v-stepper-content step="2">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{$t(errors.operation)}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>



                                                      <v-alert
                                                          :value="showresult"
                                                          style="margin-top: 1%"
                                                          border="right"
                                                          colored-border
                                                          :type="iferror?'error':'success'"
                                                          elevation="2"
                                                      >
                                                        {{text}}
                                                      </v-alert>

                                                        <v-row>


                                                            <v-col cols="12" sm="6"
                                                                   md="12">
                                                                <v-text-field @keyup="validestep(2)" type="number" :min="(generals?generals.mminrch:'0')"
                                                                :rules="montantRules" v-model="editedItem._amount"
                                                                :label="$t('reversements.montant')+'( >= : '+(generals?generals.mminrch:'')+' '+''+(devise?devise._code_alpha:'')+')'">
                                                                </v-text-field>
                                                                <span style="color: #B71C1C" v-if="errors_montant!=null">{{errors_montant}}</span>

                                                            </v-col>

                                                            <v-col cols="12" sm="6"
                                                                   md="12">

                                                                   <v-row>


                                                                     <v-col cols="12" sm="4"
                                                                            md="4" style="font-weight: bold">
                                                                                 {{$t("recharges.ratenow")}} : {{ratenow}} %
                                                                     </v-col>

                                                                    <v-col cols="12" sm="2"
                                                                            md="2" style="font-weight: bold">
                                                                          {{$t("recharges.fees")}} : {{fees}}

                                                                    </v-col>

                                                                    <v-col cols="12" sm="3"
                                                                           md="3" style="font-weight: bold">
                                                                                {{$t("recharges.net_amount")}} : {{net_amount}}
                                                                    </v-col>



                                                                   </v-row>
                                                              </v-col>


                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-select
                                                                        :rules="usermeanspaiementRules"
                                                                        v-model="editedItem._mean_id"
                                                                        :items="user_means_paiements"
                                                                        item-text="_account_name"
                                                                        item-value="_id"
                                                                        label="Choisir un moyen"
                                                                        placeholder="Choisir un moyen"
                                                                        return-object
                                                                        @change="validestep(2)"
                                                                >
                                                                    <template slot="selection" slot-scope="user_means_paiements">
                                                                        {{ user_means_paiements.item._account_name }}
                                                                          {{ user_means_paiements.item._account_surname }}
                                                                         - {{user_means_paiements.item._account_number }}
                                                                        ({{user_means_paiements.item._means_paiement._name }} - {{
                                                                        user_means_paiements.item._means_paiement._country._name }})
                                                                    </template>
                                                                    <template slot="item" slot-scope="user_means_paiements">
                                                                        {{ user_means_paiements.item._account_name }}
                                                                        {{ user_means_paiements.item._account_surname }}
                                                                         - {{
                                                                        user_means_paiements.item._account_number }} ({{
                                                                        user_means_paiements.item._means_paiement._name }} - {{
                                                                        user_means_paiements.item._means_paiement._country._name }})
                                                                    </template>
                                                                </v-select>
                                                                <span style="color: #B71C1C" v-if="errors_means!=null">{{errors_means}}</span>

                                                                <v-btn text small color="primary">
                                                                    <router-link :to="{name:'usermeanspaiments'}">
                                                                        {{$t('reversements.add_means')}}
                                                                    </router-link>
                                                                </v-btn>

                                                            </v-col>
                                                        </v-row>





                                                        <div class="text-right container">


                                                            <div class="offset-md-7 col-md-5" >
                                                                <div class="row">
                                                                  <div   class="col-md-6" style="padding: 2px">
                                                                    <v-btn
                                                                            class=" dark"
                                                                            text @click="e1 = 1">{{$t('return')}}</v-btn>

                                                                  </div>
                                                                  <div   class="col-md-6" style="padding: 2px">
                                                                    <v-btn


                                                                          color="primary" @click.prevent="save" :disabled="!step2"
                                                                    >
                                                                        {{$t('save')}}

                                                                    </v-btn>
                                                                  </div>



                                                                  </div>
                                                                </div>

                                                        </div>

                                                    </v-stepper-content>
                                                </v-stepper-items>
                                            </v-stepper>

                                        </v-form>
                                    </v-card-text>

                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>



                    <template v-slot:no-data>
                          {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>

    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from '../../mixins/helpers'

    export default {

        label: "Recharges",
          mixins:[helpers(this)],
        data() {
            return {
                snackbar:false,
                text:"",
                showresult:true,
                iferror: false,
                submitting: false,
                valid: true,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                search: '',
                dialog: '',
                dialogNote: false,
                 note:"",
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: 'Mobile',
                net_amount:0,
                fees:0,
                ratenow:1,
                generaldatas:{},
                devisedatas:{},
                e1: 1,
                typesLists:['Mobile', 'Banque'],
                typesLists2:['bystep', 'byperiode'],
                headers: [
                    {
                        text: 'Référnce',
                        align: 'start',
                        sortable: true,
                        value: '_reference',
                    },
                    {text: 'Moyen de paiement', value: 'mean'},
                    {text: 'Montant', value: '_amount'},
                    {text: 'Frais', value: '_fees'},
                    {text: 'Montant Net', value: '_net_amount'},
                    {text: 'Etat', value: '_status'},
                      {text: 'Date', value: '_created_at'},
                                    ],
                editedIndex: -1,
                editedItem: {
                    _status: 'ERROR',
                    _type:"U_R",
                    _reference:"",
                    _amount:0,
                    _fees:0,
                    _net_amount:0,
                    _mean_id:"",
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _recharge_type: 'U_R',
                    _amount: 1,
                    _owner_id: '',
                    _mean_id: '',
                    _account_number: '',
                    _type_means: 'Mobile',
                    _account_first_name: "",
                    _account_last_name: "",
                    _id: 0,
                    _created_at: 0,
                },
                periodeRules: [
                    v => !!v || 'Période requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                type_transfertRules: [
                    v => !!v || 'Type requis',
                ]
                ,
                montantRules: [
                    v => !!v || 'Montant requis',
                ],
                usermeanspaiementRules: [
                    v => !!v || 'Moyen de paiement requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('recharges.newtext') : this.$t('recharges.update')
            }
            ,
            ...mapState('user_means_paiements/', ['user_means_paiements']),
            ...mapState('recharges/', ['recharges']),
            ...mapState('reversements/', ['reversements']),
            ...mapState('settingtransactions/',['settingtransactions','load']),
            ...mapState('generalsettings/',['generals','generalmarchands']),
            ...mapState('devises/', ['devise']),


        }
        ,
        mounted() {

            let data3 = new FormData();
            data3.append("id", this.$store.getters.marchand._id);
            this.$store.dispatch('settingtransactions/getMarchandWithSetting',data3).then(response=>{
                console.log('settings',response)
                console.log("getSettingTransactionRate",this.getSettingTransactionRate());

            });

            this.initialize();

            let data = new FormData();
            data.append("id", this.$store.getters.marchand._id);
            data.append("type", "Mobile");
            this.$store.dispatch('user_means_paiements/getUser_means_paiementsBytype', data).then(response => {
                window.console.log('user_means_paiements', response)
            });
            let data2 = new FormData();
            data2.append("id", this.$store.getters.marchand._id);
            this.$store.dispatch('reversements/getReversements', data2).then(response => {
                window.console.log('reversements', response)
            });

            this.$store.dispatch('generalsettings/getGeneralSettingMarchand',this.$store.getters.marchand._id).then(response => {
                console.log('getGeneralSetting',response)
                let data3 = new FormData();
                data3.append("id", response.generalsettings.ddc);
                this.$store.dispatch('devises/getById',data3).then(response => {
                    window.console.log('devises', response)
                    this.devisedatas = response.data.devise;
                });
            });

            this.$store.dispatch('generalsettings/getGeneralSettingForMarchand',data2).then(response => {
                console.log('getGeneralSettingAdmin',response)
                this.generaldatas = response.generalsettings;
            });


        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {
              let type = "user";
              if(!this.$store.getters.marchand._id)
              {
                switch(this.$store.getters.auth.role._code)
                {
                    case "simple_user":
                            type = "user";
                        break;

                    case "admin":
                        type = "admin";
                        break;

                    default:
                        type = "marchand";
                        break;
                }
              }else{
                  type = "marchand";
              }


              let datarec = {"type":type, "id":(!this.$store.getters.marchand._id?this.$store.getters.auth._id:this.$store.getters.marchand._id)};
              this.$store.dispatch('recharges/getRecharges',datarec).then(response => {
                  window.console.log('recharges', response)
              });
            },

             shownote(vnote){
                this.note = vnote;
                this.dialogNote = true;
            },
            closeNote(){
                this.note = "Vide";
                 this.dialogNote = false;
            },
            setdefault(){
                this.e1 = 1;
                this.step1=false;
                this.step2=false;
                this.step3=false;
                $(".chooseAll").css("background-color", "");
                $(".chooseAllRev").css("background-color", "");
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
              this.showresult = false;
            },
            setdefaultClose(){
              this.e1 = 1;
              this.step1=false;
              this.step2=false;
              this.step3=false;
              $(".chooseAll").css("background-color", "");
              $(".chooseAllRev").css("background-color", "");
              this.editedItem = Object.assign({}, this.defaultItem);
              this.editedIndex = -1
                this.dialog = false;
              this.showresult = false;
            },
            chooseItem(item) {
                this.step1 = false;
                this.editedItem._type_means = item;
                $(".chooseAll").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");
                this.validestep(1)
                this.changeType(item)

            },
            validestep(step){

                switch (step) {
                    case 1:

                        if (this.typesLists.includes(this.editedItem._type_means))
                        {
                            this.step1 = true;
                        }else{
                            this.step1 = false;
                        }
                        break;


                    case 2:
                        this.errors_means = null;
                        this.errors_montant = null;
                          if (!isNaN(this.editedItem._amount))
                            {
                                if (parseFloat(this.editedItem._amount)>=parseFloat(this.generaldatas.mminrch))
                                {

                                  if (parseFloat(this.editedItem._amount)>parseFloat(this.generaldatas.mmaxrch))
                                  {
                                    this.step2 = false;
                                    this.errors_montant = this.$t("reversements.errors_montant4")+" "+this.generaldatas.mmaxrch+" "+this.devisedatas._code_alpha;

                                  }else{

                                      if(this.editedItem._mean_id!='')
                                      {
                                        let rate = this.getSettingTransactionRate(this.editedItem._mean_id._means_paiement._id);
                                        if(rate!=null)
                                        {
                                            this.fees = (parseFloat(this.editedItem._amount)*parseFloat(rate))/100;
                                              this.ratenow = rate;
                                        }else{
                                          this.fees = (parseFloat(this.editedItem._amount)*parseFloat(this.editedItem._mean_id._means_paiement._taux))/100;
                                            this.ratenow = this.editedItem._mean_id._means_paiement._taux;
                                        }
                                        this.net_amount = this.fees+parseFloat(this.editedItem._amount);
                                          this.step2 = true;
                                      }else{
                                          this.step2 = false;
                                          this.errors_means = this.$t("reversements.errors_means");
                                      }
                                  }
                                }else{
                                    this.step2 = false;
                                    this.errors_montant = this.$t("reversements.errors_montant2")+" "+this.generaldatas.mminrch+" "+this.devisedatas._code_alpha;
                                }
                            }else{
                                this.errors_montant = this.$t("reversements.errors_montant");
                            }


                        break;

                }

            },
            changeType(item) {
                console.log(item)
                let data = new FormData();
                data.append("id", this.$store.getters.marchand._id);
                data.append("type", item);
                this.$store
                    .dispatch('user_means_paiements/getUser_means_paiementsBytype', data)
                    .then(response => {
                        window.console.log('user_means_paiements', response)
                    });
            },
            cancelReverse(item) {
                console.log(item);
                let data = new FormData();
                data.append("id", item._id);
                if (item._cancel === false || item._cancel === null) {
                    data.append("cancel", true);
                    console.log("cancel : true");

                } else {
                    data.append("cancel", false);
                    console.log("cancel : false");

                }
                data.append("_user", this.$store.getters.auth._id);
                this.$store.dispatch('reversements/getUpdateCancel', data).then(response => {
                    window.console.log('reversements', response)
                });
            },

            editItem(item) {
                this.editedIndex = this.cities.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._region_id = item._region_id._id;
                this.dialog = true;

                $("#regions option").each(function () {
                    // Add $(this).val() to your list
                    // console.log($(this).val());
                    if ($(this).val() == item._region_id._id) {
                        console.log($(this).val());
                        $(this).attr("selected", "selected");
                    }
                });
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {

                 console.log("editedItem",this.editedItem);
                this.showresult = false;
                this.submitting = true;

                let data = {
                  "account_first_name": this.editedItem._mean_id._account_surname,
                  "account_last_name": this.editedItem._mean_id._account_name,
                  "account_number": this.editedItem._mean_id._means_paiement._country._code_iso_numerique+this.editedItem._mean_id._account_number,
                  "amount": this.editedItem._amount,
                  "mean_id": this.editedItem._mean_id._id,
                  "owner_id": (!this.$store.getters.marchand?this.$store.getters.auth._id:this.$store.getters.marchand._id),
                  "recharge_type": (!this.$store.getters.marchand._id?'U_R':'M_R')
                };

                let mineroute = 'recharges/setRecharge';
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;

                    if (response.data.error) {
                      this.iferror = true;
                        this.text = this.$t("recharges.text2");
                    } else {
                        this.iferror = false
                        this.text = this.$t("recharges.text1");
                        this.close();
                        this.initialize();
                    }
                  this.showresult = true;
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
            ,
            getColor(calories) {
                if (calories == "bystep") return 'green'
                else if (calories == "byperiode") return 'blue'
                else return 'green'
            },
            getColor3(calories) {
                if (calories == "SUCCESS") return 'green'
                else if (calories == "ERROR") return 'red'
                else return 'orange'
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else return 'red'
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
